module.exports = __webpack_public_path__ + "img/thy_logo.ddc4a297.png";